// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"27":"b0a58dbe","371":"1dce0c59","650":"ee662700"}[chunkId] + ".js";
};